import microuniversoApi from "app/api/microuniversoApi";
import { useAppSelector } from "app/redux/hooks";
import { RespostaAcompanhamentos } from "app/types/cliente/RespostaAcompanhamentos";
import { tratamentoErroPadrao } from "app/use-cases";
import { Dict } from "app/utils/Dict";
import { BreadCrumb } from "breadcrumb";
import globalMU from "globalMU";
import React, { useEffect, useRef, useState } from "react";
import { Breadcrumb2Container } from "../breadcrumb2/Breadcrumb2Container";
import { Acompanhamento } from "./Acompanhamento";

export type AcompanhamentoContainerProps = {
    codigoCliente: number
    onVoltar: () => void;
    passos: Dict<string, () => void>;
    onRemover: () => boolean
}

export const AcompanhamentoContainer = (props: AcompanhamentoContainerProps) => {
    const orcamento = useAppSelector((store) => store.orcamento);

    const [dados, setDados] = useState<Partial<RespostaAcompanhamentos>>();

    const passosInterno = useRef<Dict<string, () => void>>(new Dict(Object.assign({}, props.passos.map)))

    const dadosAcompanhamento = async (numeroPagina?: number) => {
        try {
            globalMU.blockUI();
            const resultado = await microuniversoApi.Cliente.DadosAcompanhamento(
                {
                    CodigoCliente: props.codigoCliente,
                    NumeroPagina: numeroPagina ?? 1,
                    TamanhoPagina: 20
                }
            );

            (!("HasErrors" in resultado))   ?  setDados(resultado) : (setDados({}), onVoltar())
            

        }
        catch (e) {
            tratamentoErroPadrao(e)
        }
        finally {
            globalMU.unblockUI();
        }
    }

    const onPassoSelecionado = (passo: string) => {
        props.onRemover()
        passosInterno.current.get(passo)()
    }

    const onVoltar = () => {
        props.onRemover()
        props.onVoltar()
    }

    useEffect(() => {
        passosInterno.current.set("Acompanhamento", () => { })
        dadosAcompanhamento()
    }, [])

    return (
        <>
            <Breadcrumb2Container
                passos={passosInterno.current.keysToList()}
                exibirBotaoLimpar={false}
                exibirBotaoVoltar={true}
                onPassoSelecionado={onPassoSelecionado}
                onBotaoVoltarClicado={onVoltar}
                id="AcompanhamentoBreadcrumb"
            />

            <Acompanhamento
                cpfcnpj={orcamento.Cliente.CpfCnpj}
                nome={orcamento.Cliente.Nome}
                dadosAcompanhamentos={dados != undefined ? dados.Entities : []}
                ActualPage={dados != undefined ? dados.ActualPage : 1}
                PageCount={dados != undefined ? dados.PageCount : 1}
                onAlterarListaSelecionada={dadosAcompanhamento}
            />
        </>
    )
} 